import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.headerText,
    visible: _ctx.showDialog,
    breakpoints: {'960px': '80vw', '640px': '100vw'},
    onHide: _ctx.onCloseDialog,
    modal: true,
    closable: false,
    position: "top",
    closeOnEscape: false
  }, {
    footer: _withCtx(() => [
      (_ctx.isUserAdmin)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: _ctx.$t('Squeeze.Validation.Dialogs.Locked.UnlockDocument'),
            icon: "mdi mdi-sort-variant-lock-open",
            class: "p-button-text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('unlockDocument')))
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        label: _ctx.$t('Squeeze.Validation.Dialogs.Locked.ShowOnly'),
        icon: "mdi mdi-eye-outline",
        class: "p-button-text",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showOnly')))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        label: _ctx.$t('Squeeze.Validation.Buttons.NextDocument'),
        icon: "mdi mdi-chevron-right",
        class: "p-button-text",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('nextDocument')))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        label: _ctx.$t('Squeeze.Validation.Dialogs.Locked.ToOverview'),
        icon: "mdi mdi-skip-backward",
        class: "p-button-text",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('backToOverview')))
      }, null, 8, ["label"])
    ]),
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.Validation.Dialogs.Locked.LockedByLongText')), 1),
      _hoisted_1,
      _hoisted_2,
      (_ctx.isUserAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.Validation.Dialogs.Locked.NextDocumentOrList')), 1),
            _hoisted_4,
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Squeeze.Validation.Dialogs.Locked.TakeOverMessage')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.Validation.Dialogs.Locked.ShowDocumentOrList')), 1),
            _hoisted_7,
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Squeeze.Validation.Dialogs.Locked.NoEditDocument')), 1)
          ]))
    ]),
    _: 1
  }, 8, ["header", "visible", "onHide"]))
}